import type { ReceivingModelDisplayData } from '~/features/my-wallet/types/receiving-model'
import {
  RECEIVING_MODEL_FAQ,
  RECEIVING_MODEL_FAQ_KEY_PATH,
  RECEIVING_MODEL_FAQ_VISIBILITY,
} from '~/features/my-wallet/constants/receiving-model-faq'
import { buildReceivingModelView } from '~/features/my-wallet/utils/receiving-model'
import { useFaqItems } from './useFaqItems'
import { useMyWalletScreenState } from './useMyWalletScreenState'

export function useReceivingModel() {
  const { paymentModel, ...screen } = useMyWalletScreenState()

  const receivingModelView = computed(() => paymentModel.value ? buildReceivingModelView(paymentModel.value) : null)

  const faqItems = useFaqItems({
    definitions: RECEIVING_MODEL_FAQ,
    visibilityRules: RECEIVING_MODEL_FAQ_VISIBILITY,
    keyPath: RECEIVING_MODEL_FAQ_KEY_PATH,
    context: receivingModelView,
  })

  const displayData = computed<ReceivingModelDisplayData | null>(() =>
    receivingModelView.value ? { ...receivingModelView.value, faqItems: faqItems.value } : null,
  )

  return {
    ...screen,
    displayData,
  }
}
